import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core'
import { FormControl, FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'Time-Picker',
    templateUrl: 'TimePicker.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: TimePickerComponent, multi: true }
    ],
    encapsulation: ViewEncapsulation.None
})
export class TimePickerComponent implements ControlValueAccessor {
    @ViewChild('customtimepicker') container;
    @Input() levelminute: number = 15;
    @Input() disabled: boolean = false;
    @Input() isTop: boolean = false;
    mytime1 = new FormControl();
    mytime2 = new FormControl();
    mytime3 = new FormControl();
    IsOpenTimePicker: boolean = false;
    multival: number = 0;
    minuteinv: number = 15;
    isclear: boolean = false;
    isTopclass: boolean = false;
    constructor() {

        document.addEventListener('click', this.offClickHandler.bind(this)); // bind on doc        
    }
    writeValue(value: any) {        
        if (new Date(value).toString() == "Invalid Date") 
            value = null;        
        if (typeof this.levelminute != "undefined") 
            this.minuteinv = this.levelminute;        
        var date = this.DateFormateFunction(value);
        this.mytime1.setValue(date);
        if (value != null && new Date(value).toString() != "Invalid Date") {
            this.mytime3.setValue(date);
            this.timemultiple();
        }
        else {
            this.mytime2.setValue(null);
            this.mytime3.setValue(null);
        }
    }
    registerOnChange(fn: (value: any) => void) {
        this.mytime3.valueChanges.subscribe(fn);
    }
    registerOnTouched() { }
    DateFormateFunction(d?: Date): Date {
        if (d != null) {
            d = new Date(d);
        }
        else {
            d = new Date();
        }
        d.setHours(d.getHours());
        d.setSeconds(0);
        var minute = d.getMinutes();
        if (this.minuteinv == 15) {
            if (minute >= 0 && minute < 15) {
                d.setMinutes(0);
            }
            else if (minute >= 15 && minute < 30) {
                d.setMinutes(15);
            }
            else if (minute >= 30 && minute < 45) {
                d.setMinutes(30);
            }
            else if (minute >= 45 && minute < 59) {
                d.setMinutes(45);
            }
            else {
                d.setMinutes(0);
                d.setHours(d.getHours() + 1);
            }
        }
        return d;
    }

    openTimePicker() {
        if (this.mytime2.value == null && this.disabled == false) {
            this.timemultiple();
        }
        if (this.disabled == false) {
            this.IsOpenTimePicker = !this.IsOpenTimePicker;
            this.isclear = false;
        }
        if (this.isTop == true) {
            this.isTopclass = true;
        }
        else {
            this.isTopclass = false;
        }
    }
    timemultiple() {
        var datetime = this.mytime1.value;
        if (datetime != null && datetime != "") {
            let d = new Date(datetime);
            var hour = d.getHours();
            var minute = d.getMinutes();
            var hours = hour < 10 ? "0" + hour : hour;
            var minutes = minute < 10 ? "0" + minute : minute;
            var ampm = "AM";
            if (hour >= 12) {
                var h = (hour - 12);
                hours = (h > 9) ? h : ((h == 0) ? 12 : ("0" + h));
                ampm = "PM";
            }
            else {
                if (hour == 0) {
                    hours = 12;
                }
            }

            this.mytime2.setValue(hours + ":" + minutes + " " + ampm);
            //wesley for 1/1/1900 get time issue
            //this.mytime3.setValue(d);
            // var temp = DatePipe.prototype.transform(new Date(), 'yyyy/MMM/dd') + ' ' + this.mytime2.value;         

            var temp = new Date().toDateString() + ' ' + this.mytime2.value;
            this.mytime3.setValue(new Date(temp));
        }
        else {
            this.mytime2.setValue(null);
            this.mytime3.setValue(null);
        }
    }
    Clear() {
        this.mytime1.setValue(this.DateFormateFunction(null));
        this.mytime2.setValue(null);
        this.mytime3.setValue(null);
        this.isclear = false;
    }
    offClickHandler(event: any) {
        if (!this.container.nativeElement.contains(event.target)) { // check click origin
            this.IsOpenTimePicker = false;
            this.isclear = false;
        }
    }
    customtimepickerclose() {
        this.IsOpenTimePicker = false;
    }
    timepickerover() {
        if (this.mytime2.value != null && this.mytime2.value != "" && this.disabled == false) {
            this.isclear = true;
        }
    }
    changed() {
        this.timemultiple();
    }
}